import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { doGetAllMessageLogs } from "./thunk";

const messageLogsAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const messageLogSlice = createSlice({
  name: "messageLog",
  initialState: {
    isFetching: false,
    status: "idle",
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllMessageLogs.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doGetAllMessageLogs.fulfilled, (state, action) => {
      const { messageLogs, meta } = action.payload;
      state.isFetching = false;
      state.status = "succeeded";
      state.metadata = meta;
      messageLogsAdapter.setAll(state, messageLogs);
    });
    builder.addCase(doGetAllMessageLogs.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
  },
});

export const {
  selectAll: selectAllMessageLogs,
  selectById: selectMessageLogById,
  selectIds: selectMessageLogIds,
} = messageLogsAdapter.getSelectors(state => state.messageLog);

const { reducer: messageLogReducer } = messageLogSlice;
export default messageLogReducer;
